import { Box } from '@mentimeter/ragnar-ui/box';
import type { DiscussResultsExperimentVersion } from './ViewOnlyFooter';

export const ViewOnlyCommentDrawerExperiment = ({
  version,
}: {
  version: DiscussResultsExperimentVersion;
}) => {
  return <Box>Experiment component container {version}</Box>;
};
